import { useEffect } from 'react';

// Default social preview image (shared). Note: current asset is 988x998.
export const OG_IMAGE =
  'https://customer-assets.emergentagent.com/job_valuare-jr-preview/artifacts/ld82pk4p_upscalemedia-transformed.png';

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Reliable per-route head management (React 19 compatible, no external dep).
 * Reuses the tags already present in index.html and creates the missing ones,
 * so there is exactly one tag of each kind and it is always route-specific.
 */
export function useSeo({
  title,
  description,
  url,
  image = OG_IMAGE,
  type = 'website',
  locale = 'pt_PT',
  siteName = 'Valuare JR'
}) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('name', 'description', description);

    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:locale', locale);
    upsertMeta('property', 'og:site_name', siteName);
    upsertMeta('property', 'og:image', image);

    upsertMeta('name', 'twitter:card', image ? 'summary_large_image' : 'summary');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', image);

    upsertLink('canonical', url);
  }, [title, description, url, image, type, locale, siteName]);
}
